import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnitsSelected = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 1C7.44772 1 7 1.44772 7 2V7H3C2.44772 7 2 7.44772 2 8V21C2 21.5523 2.44772 22 3 22H8H16H21C21.5523 22 22 21.5523 22 21V8C22 7.44772 21.5523 7 21 7H17V2C17 1.44772 16.5523 1 16 1H8ZM11 6H13V8H11V6ZM6 11H8V13H6V11ZM16 11H18V13H16V11ZM13 11H11V13H13V11ZM18 16H16V18H18V16ZM6 16H8V18H6V16ZM13 16H11V20H13V16Z",
		fill: "#0FAFAF"
	})
});
export default SvgUnitsSelected;
